export const localStorageVar = {
    token: 'token',
    loginInfo: 'info',
    accountLevel: 'accountLevel',
    distribution: 'distInfo',
    businessSettings: 'business-settings',
    distributionSettings: 'distribution-settings',
    franchises:'franchises',
    activeFranchise:'active-franchise',
    permissions:'permissions'
}